import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { HeroProfileComponentType } from '@application/Types/ComponentTypes'
import { parseUtmParamsInHtml } from '@src/Application/Utils/generalUtils'

import { Title } from './HeroHeader.styled'

export const HeroHeader = ({ header, mode }: Pick<HeroProfileComponentType, 'header' | 'mode'>): JSX.Element => {
    return (
        <Title $mode={mode}>
            <Html content={parseUtmParamsInHtml(header?.data.childMarkdownRemark.html)} />
        </Title>
    )
}
